import FormFields from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/form-fields';
import { PageSEO } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/page-seo';

export const ContactContent = () => {
  return (
    <>
      <PageSEO pathname="/contact" />
      <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Left Column - Content */}
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-6 italic">
                Contact Us
              </h2>
              <div className="space-y-4 text-[#333333]">
                <p>
                  We're here to assist you with your RED-E-BIN reservation, answer any questions, or make changes to your booking if needed. Whether you're planning ahead or need help on short notice, our team is ready to ensure your experience is smooth and hassle-free.
                </p>
                <p>
                  Need immediate assistance? Click on the yellow chat button at the bottom of the page, and one of our team members will be online to help you in just a moment. We're here to provide quick and responsive support so you can focus on your project.
                </p>
                <p>
                  Prefer to talk or text? You can contact us directly at{' '}
                  <a href="tel:9529312577" className="text-[#E31837] hover:underline font-semibold">
                    (952) 931-2577
                  </a>
                  . We understand that sometimes it's easier to speak with someone directly, and our friendly team is pleased to assist however we can. Whether you have a question about our services, need to adjust your reservation, or want to learn more about what makes RED-E-BIN the best choice for your needs, our friendly team is just a call or text away.
                </p>
                <p>
                  Our hours of operation are <strong>Monday through Friday, 8:00 AM to 5:00 PM</strong>. While we strive to respond as quickly as possible during these times, you can also leave us a message after hours, and we'll get back to you as soon as we're back online.
                </p>
                <p>
                  At RED-E-BINS, we pride ourselves on providing not only quality dumpster rental services but also exceptional customer support every step of the way. Whatever your needs, we're here to make it simple, convenient, and efficient to get your project done.
                </p>
                <p>
                  Click, call, or text today—Contact Us Today!
                </p>
              </div>
            </div>

            {/* Right Column - Form */}
            <div>
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-2xl font-bold text-[#333333] mb-2 italic">
                  Set up service
                </h3>
                <p className="text-sm text-[#333333] mb-4">
                  Our simple online dumpster rental process
                </p>
                <p className="text-sm text-[#333333] mb-6">
                  Fill out the contact form and we will email or call you as soon as we can
                </p>
                <FormFields />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

